var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{staticClass:"sidebar-lg col"},[_c('div',{staticClass:"sidebar-bg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }